export const GRBAS_ATTRIBUTE_DEFINITIONS = [
  {
    id: "overallSeverity",
    label: "Grade",
    compactLabel: "G",
  },
  {
    id: "roughness",
    label: "Roughness",
    compactLabel: "R",
  },
  {
    id: "breathiness",
    label: "Breathiness",
    compactLabel: "B",
  },
  {
    id: "asthenia",
    label: "Asthenia",
    compactLabel: "A",
  },
  {
    id: "strain",
    label: "Strain",
    compactLabel: "S",
  },
];

export const GRBAS_SCALE_VALUES = [
  [0, "Normal"],
  [1, "Mild"],
  [2, "Moderate"],
  [3, "Severe"],
];

export function buildCompactGRBASNotation(values = {}) {
  const segments = GRBAS_ATTRIBUTE_DEFINITIONS.map(
    ({ id, compactLabel }) =>
      `${compactLabel}${Number(values?.[id] ?? 0)}`
  );

  return `GRBAS: ${segments.join(" ")}`;
}

export function buildExpandedGRBASText(values = {}) {
  return GRBAS_ATTRIBUTE_DEFINITIONS.map(
    ({ id, label }) =>
      `${label}: ${Number(values?.[id] ?? 0)}`
  ).join("; ");
}

export function buildExpandedGRBASRows(values = {}) {
  return GRBAS_ATTRIBUTE_DEFINITIONS.map(
    ({ id, label }) => ({
      id,
      label,
      value: Number(values?.[id] ?? 0),
    })
  );
}
